export const StatusStylesMixins = {
  data: () => ({
    newStatus: {
      mainStyle: {
        display: "flex",
        padding: "1",
        "justify-content": "space-around",
        background: "#dbe9fe",
        width: "auto",
        height: "auto",
        "border-radius": "5px",
      },
      textStyle: {
        color: "#5fa5f9",
        "text-align": "center",
        margin: "0px auto",
      },
    },
    awaitingStatus: {
      mainStyle: {
        display: "flex",
        padding: "1",
        "justify-content": "space-around",
        background: "rgb(247 232 172 / 87%)",
        width: "auto",
        height: "auto",
        "border-radius": "5px",
      },
      textStyle: {
        color: "#d97707",
        "text-align": "center",
        margin: "0px auto",
      },
    },
    fulfillingStatus: {
      mainStyle: {
        display: "flex",
        padding: "1",
        "justify-content": "space-around",
        background: "rgb(255 211 163)",
        width: "auto",
        height: "auto",
        "border-radius": "5px",
      },
      textStyle: {
        color: "#fb923c",
        "text-align": "center",
        margin: "0px auto",
      },
    },
    completedStatus: {
      mainStyle: {
        display: "flex",
        padding: "1",
        "justify-content": "space-around",
        background: "#d1fae4",
        width: "auto",
        height: "auto",
        "border-radius": "5px",
      },
      textStyle: {
        color: "#45d69f",
        "text-align": "center",
        margin: "0px auto",
      },
    },
    canceledStatus: {
      mainStyle: {
        display: "flex",
        padding: "1",
        "justify-content": "space-around",
        background: "#fecaca",
        width: "auto",
        height: "auto",
        "border-radius": "5px",
      },
      textStyle: {
        color: "#dc2625",
        "text-align": "center",
        margin: "0px auto",
      },
    },
  }),
};
